import { documentHasElements } from "modules/dom";

documentHasElements(".js-embedded-video-block", (videoBlocks) => {
    videoBlocks.forEach((videoBlock) => {

        const youtubeImageContainer = videoBlock.querySelector<HTMLElement>(".youtube .image-container");
        const youtubePlayButton = videoBlock.querySelector<HTMLElement>(".youtube .image-container");
        const youtubeVideoContainer = videoBlock.querySelector<HTMLDivElement>(".youtube .video-container");
        const youtubeCloseButton = videoBlock.querySelector<HTMLDivElement>(".youtube .video-container button");
        const youtubeEmbedUrl = videoBlock.querySelector<HTMLDivElement>(".youtube .embed-url")?.innerHTML;

        let isPlaying = false;

        youtubePlayButton?.addEventListener("click", (e) => {
            e.preventDefault();
            e.stopPropagation();
            if (isPlaying) return;
            isPlaying = true;

            setTimeout(() => {
                const iframe = document.createElement('iframe');
                iframe.setAttribute('src', `https://www.youtube.com/embed/${youtubeEmbedUrl}?autoplay=1&rel=0&showinfo=0`);
                iframe.setAttribute('frameborder', '0');
                iframe.setAttribute('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share');
                iframe.setAttribute('allowfullscreen', 'allowfullscreen');
                iframe.setAttribute('width', '100%');
                iframe.setAttribute('height', 'auto');

                youtubeVideoContainer?.appendChild(iframe);
            }, 900);

            setTimeout(() => {
                youtubeImageContainer?.classList.add("played");
            }, 2000);

            setTimeout(() => {
                youtubeVideoContainer?.classList.add("played");
            }, 3000);

        });

        youtubeCloseButton?.addEventListener("click", () => {

            const youtubeVideo = videoBlock.querySelector<HTMLDivElement>(".youtube iframe");
            youtubeVideoContainer?.classList.add("closed");

            setTimeout(() => {
                youtubeImageContainer?.classList.remove("played");
                youtubeVideoContainer?.classList.remove("played");
                youtubeVideoContainer?.classList.remove("closed");

                youtubeVideo?.remove();
                isPlaying = false;
            }, 600);
        });

    });
});